import styled from 'astroturf/react'
import { useState } from 'react'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const greyLevel5 = 'var(--color-grey-3, #CCCCCC)'
const textColorL2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
import { PaymentElement } from '@stripe/react-stripe-js'
import { ErrorMessage } from '@calendly/form'
import { useBooleanState } from '@calendly/hooks'
import _PaymentElementWrapper from "payment_element_field-PaymentElementWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/stripe/payment_element_field.js?styleId=PaymentElementWrapper";


const getStyle = () => ({
  base: {
    color: '#1a1a1a',
    fontSize: '16px',
    fontFamily: 'Proxima Nova, sans-serif',
    lineHeight: '20px',
    fontSmoothing: 'antialiased',

    '::placeholder': {
      color: textColorL2,
    }
  }
})

const PaymentElementWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentElementWrapper",
  styles: _PaymentElementWrapper,
  attrs: props => ({
    ...props,
    style: getStyle()
  })
})

export const PaymentElementField = ({ onChange, error, disabled, ...props }) => {
  const [hasError, setHasError] = useState(false)
  const [hasFocus, focus, blur] = useBooleanState(false)

  const handleChange = (changeObject) => {
    setHasError(Boolean(changeObject.error))
    onChange(changeObject)
  }

  const paymentElementOptions = {
    paymentMethodOrder: [
      'card',
      'apple_pay',
      'google_pay',
      'pay_by_bank'
    ]
  }

  return (
    <div {...props}>
      <PaymentElementWrapper
        hasError={hasError}
        hasFocus={hasFocus}
        onChange={handleChange}
        onFocus={focus}
        onBlur={blur}
      >
        <PaymentElement options={paymentElementOptions} />
      </PaymentElementWrapper>
      <ErrorMessage message={error} />
    </div>
  )
}
